
// AUTHORITATIVE Firestore block for TradesPage
// Guarantees TradesPage never hydrates from Firestore

export function blockFirestoreForTradesPage() {
  if (typeof window === 'undefined') return;

  // Feature flag stored in session (scoped to page load)
  sessionStorage.setItem('__BLOCK_FIRESTORE_TRADES__', '1');
}

export function isFirestoreBlockedForTradesPage(): boolean {
  if (typeof window === 'undefined') return false;
  return sessionStorage.getItem('__BLOCK_FIRESTORE_TRADES__') === '1';
}
